import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-increase",
  "use": "icon-increase-usage",
  "viewBox": "0 0 13.389 13.389",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13.389 13.389\" id=\"icon-increase\">\r\n  <path id=\"icon-increase_错误\" class=\"cls-1\" d=\"M123.131,114.528l-.864-.864-3.87,3.876-3.87-3.876-.864.864,3.876,3.87-3.876,3.87.864.864,3.87-3.876,3.87,3.876.864-.864-3.876-3.87Z\" transform=\"translate(6.694 -160.745) rotate(45)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol